import React from 'react';
import {Modal, Button} from 'antd';

const GiftCreationError = ({onSubmit}: any): JSX.Element => {
    return (
        <Modal
            visible={true}
            closable={false}
            title="Заявка не відправлена"
            footer={[
                <div key="2" />,
                <Button key="1" color="primary" className="custom-btn custom-btn__remove" onClick={onSubmit}>
                    OK
                </Button>,
            ]}
        >
            <div>Під час створення заявки виникла помилка. Спробуйте надіслати анкету пізніше.</div>
        </Modal>
    );
};

export default GiftCreationError;
